import React from 'react';

class ProfileIcon extends React.Component {

    render() {
        return (
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16.8351 6.16486C16.8351 9.56975 14.2007 12.3315 10.9527 12.3315C7.70473 12.3315 5.07031 9.55086 5.07031 6.16486C5.07031 2.77887 7.70477 0.0170898 10.9527 0.0170898C14.2006 0.0170898 16.8351 2.75997 16.8351 6.16486ZM15.2833 6.16486C15.2833 3.6679 13.3345 1.62497 10.9527 1.62497C8.57085 1.62497 6.62209 3.66786 6.62209 6.16482C6.62209 8.66178 8.57089 10.7047 10.9527 10.7047C13.3345 10.7047 15.2833 8.66182 15.2833 6.16486Z"
                      fill="#3D77BC"></path>
                <path fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.2019 21.9598H0.77589C0.342833 21.9598 0 21.6004 0 21.1464C0 16.8713 3.32013 13.4097 7.38006 13.4097H14.5977C18.6757 13.4097 21.9778 16.8902 21.9778 21.1464C21.9778 21.6004 21.6349 21.9598 21.2019 21.9598ZM14.5977 15.0364H7.38006C4.42083 15.0364 1.98484 17.3632 1.60592 20.333H20.3718C19.9929 17.3442 17.5569 15.0364 14.5977 15.0364Z"
                      fill="#3D77BC"></path>
            </svg>
        )
    }

}

export default ProfileIcon;
